module.exports = __webpack_public_path__ + "images/common/pictoMomentumWhite.802f1bfa.svg";